<script>
import DocumentListComponent from "./components/resources/DocumentListComponent.vue";
import AutoriryComponent from "./components/resources/AutoriryComponent.vue";
import NewsComponent from "./components/resources/NewsComponent.vue";
import ITCGridComponent from "./components/resources/ITCGridComponent.vue";
import BoxIconGridComponent from "./components/resources/BoxIconGridComponent.vue";
import MultiSliderComponent from "./components/resources/MultiSliderComponent.vue";
import FrecuentAccessComponent from "./components/resources/FrecuentAccessComponent.vue";
import GridLinkComponent from "./components/resources/GridLinkComponent.vue";
import CardGridComponent from "./components/resources/CardGridComponent.vue";

export default {
  name: "HomeView",
  components: {
    /* eslint-disable */
    DocumentListComponent,
    /* eslint-disable */
    AutoriryComponent,
    /* eslint-disable */
    NewsComponent,
    /* eslint-disable */
    ITCGridComponent,
    /* eslint-disable */
    BoxIconGridComponent,
    /* eslint-disable */
    MultiSliderComponent,
    /* eslint-disable */
    FrecuentAccessComponent,
    /* eslint-disable */
    GridLinkComponent,
    /* eslint-disable */
    CardGridComponent,
    /* eslint-disable */
    ITCGridComponent,
  },
  data() {
    return {
      site: 23,
      innerWidth: window.innerWidth,
    };
  },
  mounted() {
    document.title = process.env.VUE_APP_TITLE;
  },
  created() {
    window.addEventListener("resize", this.updateWidth);
  },
  destroyed() {
    window.removeEventListener("resize", this.updateWidth);
  },
};
</script>

<template>

  <MultiSliderComponent v-if="this.innerWidth > 768" titulo="" :elementos="1" :mostrar-titulo="false"
    :mostrar-bordes="true" :ajustar="true" :data="[
    {
      desc: null,
      imagen: require('@/assets/img/Banner-Archivo.jpg'),
      url: 'https://archivogeneral.sanjuan.gob.ar/',
      target: 'blank_',
    },
  ]" />

  <MultiSliderComponent v-if="this.innerWidth < 768" titulo="" :elementos="1" :mostrar-titulo="false"
    :mostrar-bordes="true" :ajustar="true" :data="[
      {
        desc: null,
        imagen: require('@/assets/img/Banner-Mobile.jpg'),
        url: 'https://rentas.dgrsj.gob.ar/',
        target: 'blank_',
      },
    ]" />

  <ITCGridComponent columnas="2" :data="[
    {
      desc: null,
      icon: 'ptn-i-documento',
      target: '_self',
      title: 'Consulta de Expedientes',
      url: '?uid=CUMV-VIEW-ExpedientesComponent',
    },
    {
      desc: null,
      icon: 'question_answer',
      target: '_self',
      title: 'Consultas y Solicitudes',
      url: '?uid=CUMV-VIEW-FormComponent',
    },
  ]" />
  <NewsComponent />

  <!-- <BoxIconGridComponent titulo="Secciones" :data="[
    // {
    //   desc: null,
    //   icon: 'ptn-i-redtulum',
    //   target: '_blank',
    //   title: 'Red Tulum',
    //   url: 'https://www.redtulum.gob.ar/',
    // },
    {
      desc: null,
      icon: 'ptn-i-defensoria',
      target: '_blank',
      title: 'Red Provincial de Promotores Territoriales en Derechos Humanos',
      url: 'https://docs.google.com/forms/d/1q5wKP9EtkDZcLfWf3Rfze83kXwA_41xzsx6gNpH3450/viewform?edit_requested=true',
    }
  ]" /> -->

  <!--   <MultiSliderComponent
    titulo="Secciones"
    :elementos="1"
    mostrar-indicadores="false"
    :mostrarTitulo="false"
    :ajustar="true"
    :filtros="{ site: this.site }"
  /> -->

  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <DocumentListComponent resultados="5" :show-fecha="false" titulo="Guía de Trámites" :items="[
          {
            target: '_blank',
            title: 'TURNOS DEL REGISTRO CIVIL',
            url: 'https://tramite.sanjuan.gob.ar/tramite/org/152',
            fecha: '01/01/2022',
          },
          {
            target: '_blank',
            title: 'IMPRESIÓN DE BOLETAS DE PAGO DE ACTAS DE INFRACCIÓN (MULTAS) DE TRÁNSITO',
            url: 'https://serviciosmingobierno.sanjuan.gov.ar/Transito_4/view_5/',
            fecha: '01/01/2022',
          },
          {
            target: '_blank',
            title: 'MODELOS DE CERTIFICADOS DE DOMICILIO (RESIDENCIA) CONVIVENCIA Y SUPERVIVENCIA',
            url: 'https://tramite.sanjuan.gob.ar/tramite/d/57',
            fecha: '01/01/2022',
          },
          {
            target: '_blank',
            title: 'OBTENCIÓN DEL NUEVO DNI',
            url: 'https://tramite.sanjuan.gob.ar/tramite/org/152',
            fecha: '01/01/2022',
          }
        ]" />
      </div>
      <div class="col-md-6">
        <DocumentListComponent resultados="5" :show-fecha="false" titulo="Trámites en Línea" :items="[
          {
            target: '_blank',
            title: 'Antecedentes - Secretaría de Estado de Seguridad y Orden Público',
            url: 'https://antecedentes.sanjuan.gob.ar/',
            fecha: '01/01/2022',
          },
          {
            target: '_blank',
            title: 'Multas Tránsito',
            url: 'https://serviciosmingobierno.sanjuan.gov.ar/Transito_4/view_5/',
            fecha: '01/01/2022',
          },
        ]" />
      </div>
    </div>
  </div>
  <CardGridComponent columnas="1" :data="[
    {
      target: '_self',
      title: 'Licitaciones',
      url: 'https://licitaciones.sanjuan.gob.ar/',
    },
  ]" />

  <Autoriry-component :showProtocolo="false" :showLinks="true" :data="[
    {
      title: 'Laura Palma',
      subtitle: 'Ministra de Gobierno',
      imagen: require('@/assets/img/min_de_gobierno.jpg'),
    },
  ]" />
</template>
